import React from "react";
import { useMediaQuery } from "react-responsive";
import { useSearchParams } from "react-router-dom";

import { CiSearch } from "react-icons/ci";
import { IoMdMenu } from "react-icons/io";

const Search = ({ setToggleSearch, setClickSideMenu = null }) => {
  const [searchParams] = useSearchParams();
  const isTablet = useMediaQuery({ query: "(max-width:1050px)" });
  const keyword = searchParams.get("keyword");

  return (
    <div className="search" onClick={() => !isTablet && setToggleSearch(true)}>
      <span>{keyword || "주문하실 상품을 검색해주세요"}</span>
      <i onClick={() => isTablet && setToggleSearch(true)}>
        <CiSearch />
      </i>
      {isTablet && setClickSideMenu && (
        <i onClick={() => setClickSideMenu(true)}>
          <IoMdMenu />
        </i>
      )}
    </div>
  );
};

export default Search;
